import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Button, colors, Grid, Typography, Hidden} from '@material-ui/core';
import {SectionHeader} from 'components/molecules';
import {CardPromo} from "components/organisms";
import {Video} from "components/atoms";

const useStyles = makeStyles((theme) => ({
    fontWeight900: {
        fontWeight: 900,
    },
    secondary: {
        color: theme.palette.secondary.main
    }
}));


function SetupItems() {
    return (
       <Box marginBottom={2} padding={2} border="1px solid #ccc" borderRadius="4px">
           <Grid container spacing={2}>
               <Grid item xs={12} md={4}>
                   <CardPromo
                      liftUp
                      title="Setup your Revenue Rules"
                      subtitle="Configure your Revenue Recognition Methodology"
                      description="Configure your standalone selling price library, revenue recognition and commission rules."
                      fontIconClass="fas fa-money-bill-wave"
                      color={colors.pink}
                      variant="outlined"
                   />
               </Grid>
               <Grid item xs={12} md={4}>
                   <CardPromo
                      liftUp
                      title="Sync your Data"
                      subtitle="Get your Data into REVLOCK"
                      description="REVLOCK can connect to your sales and billing systems to intelligently pull in data and produce revenue recognition results."
                      fontIconClass="fas fa-sync"
                      color={colors.purple}
                      variant="outlined"
                   />
               </Grid>
               <Grid item xs={12} md={4}>
                   <CardPromo
                      liftUp
                      title="Confirm Results"
                      subtitle="Review Roll-forward and Journals"
                      description="Analyze deferred revenue and recognized revenue analytics and set your accounting close period according to your own schedule."
                      fontIconClass="fas fa-book"
                      color={colors.blue}
                      variant="outlined"
                   />
               </Grid>
           </Grid>
       </Box>
    );
}


const GetStarted = ({className, ...rest}) => {
    const classes = useStyles();
    
    
    const title = (
       <Grid container direction={"column"} justify={"center"} alignItems={"center"}>
           <Grid item xs={12}>
               <Hidden smUp>
                   <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
                       <Typography variant="h4" component="span" className={classes.fontWeight900}>
                           Setup
                       </Typography>
                       <div style={{padding: 16, margin: 16}}>
                           <Video width={232} height={60}
                                  src={"https://s3.amazonaws.com/content.rev-lock.com/images/Animated-Logo-No-Sound.mp4"}/>
                       </div>
                       <Typography variant="h4" component="span" className={classes.fontWeight900}>Today</Typography>
                   </Box>
               </Hidden>
               <Hidden smDown>
                   <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                       <Typography variant="h4" component="span" className={classes.fontWeight900}>
                           Setup
                       </Typography>
                       <div style={{padding: 16, margin: 16}}>
                           <Video width={232} height={60}
                                  src={"https://s3.amazonaws.com/content.rev-lock.com/images/Animated-Logo-No-Sound.mp4"}/>
                       </div>
                       <Typography variant="h4" component="span" className={classes.fontWeight900}>Today</Typography>
                   </Box>
               </Hidden>
           </Grid>
           <Grid item xs={12} style={{marginTop: 16}}>
               <Typography component="span" variant="h2" style={{fontWeight: 800}} color="primary">It's
                   easy</Typography>
           </Grid>
       </Grid>);
    
    const subtitle = 'Be Up-and-Running in Days, Not Months.';
    const button = (
       <Button
          size="large"
          variant="contained"
          color="primary"
          onClick={() => window.open('https://www.chargebee.com/docs/revrec/quick-start.html')}>
           Get started
       </Button>
    );
    return (
       <div className={className} {...rest}>
           
           <SectionHeader
              title={title}
              subtitle={subtitle}
              align="center"
              titleProps={{
                  variant: 'h2',
                  color: 'textPrimary',
                  className: classes.fontWeight900,
              }}
              ctaGroup={[button]}
           />
           <SetupItems/>
       </div>
    );
};

GetStarted.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};

export default GetStarted;
